/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Button } from "antd-mobile";
import { FormattedMessage, injectIntl } from "react-intl";
import { intl } from "../../../services/intlGlobalProvider";
import { FaEye } from "react-icons/fa";
import zxcvbn from "zxcvbn";
import Theme from "../../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const StyledTitle = styled.span`
  font-size: 1.4em;
  line-height: 2.1em;
  font-weight: 900;
`;

const StyledDescription = styled.span`
  margin-top: 3%;
  color: grey;
  font-size: 0.9em;
  line-height: 1.3em;
`;

const StyledErrorMesage = styled.span`
  margin-top: 2%;
  font-size: 0.8em;
  color: red;
  height: 1em;
`;

const StyledPasswordContainer = styled.div`
  margin-top: 15%;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin: 5px 0;
  border-radius: 25px;
  background: "white";
  border: 0.5px solid lightgrey;
  padding: 0.3em 1.8em;
  font-size: 1.1em;
  min-height: 2.2em;
`;

const StyledConfirmPasswordContainer = styled(StyledPasswordContainer)`
  margin-top: 10px;
`;

const StyledInput = styled.input`
  flex: 1;
  border: none;
`;

const StyledPasswordStrengthContainer = styled.div`
  margin: 0 2.5%;
  width: 95%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 5px;
  font-size: 0.9em;
`;

const StyledButton = styled(Button)`
  margin-top: 15%;
  width: 100%;
  box-shadow: 0 4px 6px -5px grey;
  && {
    cursor: pointer;
    font-size: 1em
    border-radius: 25px;
    color: white;
    background-color: ${props =>
      props.disabled ? "grey" : Theme.PrimaryColor};
  }
`;

class EnterNewPassSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visibility: false,
      cVisibility: false,
      length: 0,
      score: 0,
      error: null
    };
  }

  handleChange = txt => {
    const { newConfirmPassword, onNewPasswordChanged } = this.props;
    let score = 0;
    let result = null;

    if (txt.length >= 8) {
      result = zxcvbn(txt, []);
      score = result.score;
    }

    this.setState(
      {
        score: score,
        length: txt.length
      },
      () => {
        if (onNewPasswordChanged) onNewPasswordChanged(txt);
      }
    );
    this.handlePasswordConsistent(txt, newConfirmPassword);
  };

  handleConfirmPasswordChange = txt => {
    const { newPassword, onNewConfirmPasswordChanged } = this.props;

    onNewConfirmPasswordChanged && onNewConfirmPasswordChanged(txt);
    this.handlePasswordConsistent(newPassword, txt);
  };

  handlePasswordConsistent = (password, confirmPasswod) => {
    const { intl } = this.props;

    if (password !== confirmPasswod) {
      this.setState({
        error: intl.formatMessage({ id: "reset.password.confirm.pass.error" })
      });
    } else {
      this.setState({
        error: null
      });
    }
  };

  getStrengthColor = score => {
    switch (score) {
      case 0:
        return "red";
      case 1:
        return "red";
      case 2:
        return "green";
      case 3:
        return "limegreen";
      case 4:
        return "chartreuse";
    }
  };

  getStrengthText = score => {
    switch (score) {
      case 0:
        return <FormattedMessage id="app.pass.weak" />;
      case 1:
        return <FormattedMessage id="app.pass.weak" />;
      case 2:
        return <FormattedMessage id="app.pass.medium" />;
      case 3:
        return <FormattedMessage id="app.pass.good" />;
      case 4:
        return <FormattedMessage id="app.pass.strong" />;
    }
  };

  render() {
    const { loading, newPassword, newConfirmPassword, onSubmit } = this.props;
    const { visibility, cVisibility, length, score, error } = this.state;

    return (
      <StyledContainer>
        <StyledTitle>
          <FormattedMessage
            id="forgot.password.enter.new.pass.title"
            defaultMessage="New Password"
            description="Forgot Password Page Enter New Password Title"
          />
        </StyledTitle>
        <StyledPasswordContainer>
          <StyledInput
            defaultValue={newPassword}
            type={visibility ? "text" : "password"}
            placeholder={intl.formatMessage({
              id: "forgot.password.enter.new.pass.placeholder"
            })}
            onChange={txt => this.handleChange(txt.target.value)}
          />
          <FaEye
            style={{
              marginLeft: "10px",
              color: visibility ? "black" : "gray",
              fontSize: "1.2em"
            }}
            onClick={() => this.setState({ visibility: !visibility })}
          />
        </StyledPasswordContainer>
        <StyledConfirmPasswordContainer>
          <StyledInput
            defaultValue={newConfirmPassword}
            type={cVisibility ? "text" : "password"}
            placeholder={intl.formatMessage({
              id: "forgot.password.enter.new.confirm.pass.placeholder"
            })}
            onChange={txt => this.handleConfirmPasswordChange(txt.target.value)}
          />
          <FaEye
            style={{
              marginLeft: "10px",
              color: cVisibility ? "black" : "gray",
              fontSize: "1.2em"
            }}
            onClick={() => this.setState({ cVisibility: !cVisibility })}
          />
        </StyledConfirmPasswordContainer>
        {length > 0 ? (
          <StyledPasswordStrengthContainer
            style={{ color: this.getStrengthColor(score) }}
          >
            {this.getStrengthText(score)}
          </StyledPasswordStrengthContainer>
        ) : null}
        {error ? <StyledErrorMesage>{error}</StyledErrorMesage> : null}
        <StyledDescription>
          <FormattedMessage
            id="forgot.password.enter.new.pass.description"
            defaultMessage="It must have at least 8 characters, combining 1 capital letter, 1 small letter and number to have a secure password."
            description="Forgot Password Page Enter New Password Description"
          />
        </StyledDescription>
        <StyledButton
          disabled={
            loading ||
            newPassword.length < 8 ||
            newConfirmPassword !== newPassword
          }
          loading={loading}
          activeStyle={{ backgroundColor: Theme.ActivePrimary }}
          onClick={() => onSubmit && onSubmit()}
        >
          {loading ? (
            <FormattedMessage
              id="app.loading"
              defaultMessage="Loading"
              description="Loading Title"
            />
          ) : (
            <FormattedMessage
              id="forgot.password.next.btn"
              defaultMessage="NEXT >"
              description="Forgot Password Page Next Btn Title"
            />
          )}
        </StyledButton>
      </StyledContainer>
    );
  }
}

EnterNewPassSection.propTypes = {
  intl: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
  newPassword: PropTypes.string.isRequired,
  newConfirmPassword: PropTypes.string.isRequired,
  onNewPasswordChanged: PropTypes.func.isRequired,
  onNewConfirmPasswordChanged: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

EnterNewPassSection.defaultProps = {
  loading: false,
  error: null,
  newPassword: "",
  newConfirmPassword: "",
  onNewPasswordChanged: null,
  onSubmit: null
};

export default injectIntl(EnterNewPassSection);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage/EnterNewPassSection/index.js